import * as React from 'react';
import { css, html } from 'react-strict-dom';

import { RouterLink } from './RouterLink';

type Props = Readonly<{
  name: React.ReactNode;
  left?: React.ReactNode;
  to?: string;
  onClick?: () => unknown;
}>;

export default function DropdownItem({ name, left, to, onClick }: Props) {
  const content = (
    <>
      {left}
      <html.span>{name}</html.span>
    </>
  );

  if (to) {
    return (
      <RouterLink to={to} onClick={onClick} {...css.props(styles.item)}>
        {content}
      </RouterLink>
    );
  }

  return (
    <html.a style={styles.item} onClick={onClick}>
      {content}
    </html.a>
  );
}

const styles = css.create({
  item: {
    display: 'flex',
    alignItems: 'center',
    paddingBlock: 10,
    paddingInline: 15,
    color: 'inherit',
    cursor: 'pointer',
    transition: 'background-color 0.25s',
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: '#ddd',
    ':hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.07)',
    },
  },
});
